import { useQuery } from 'react-query';

import { axiosInstance } from '../axiosInstance';

export interface AmenityReservation {
  startTime: number;
  reservations: number;
}

const getAmenityReservationsKey = (amenityId: number, date: number) => ['amenity-reservations', amenityId, date];

const getAmenityReservations = async (amenityId: number, date: number) => {
  const { data } = await axiosInstance.get<AmenityReservation[]>(`/amenity/${amenityId}/availability/${date}`);
  return data;
};

export const useGetAmenityReservations = (amenityId: number, date: number) =>
  useQuery({
    enabled: !!amenityId,
    queryKey: getAmenityReservationsKey(amenityId, date),
    queryFn: () => getAmenityReservations(amenityId, date),
    // Note: refetch every 15 minutes
    refetchInterval: 15 * 60 * 1000,
    retry: false,
  });
